import { render, staticRenderFns } from "./CaseActionModal.vue?vue&type=template&id=676a43b0&scoped=true"
import script from "./CaseActionModal.vue?vue&type=script&lang=js"
export * from "./CaseActionModal.vue?vue&type=script&lang=js"
import style0 from "./CaseActionModal.vue?vue&type=style&index=0&id=676a43b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676a43b0",
  null
  
)

export default component.exports